import React from "react";
import { Box } from "@mui/material";
import WorkPage from "../components/WorkPage";

const Projects = () => {
  return (
    <Box>
      <WorkPage />
    </Box>
  );
};

export default Projects;
